if (!customElements.get('collection-with-products')) {
  class CollectionWithProducts extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    async init() {
      this.collectionContainer = this.querySelector('[collection-slider]');
      this.cwpBullets = this.querySelectorAll('[cwp-bullets]');
      this.cwpButton = this.querySelector('[cwp-btn]');
      this.cwpHeading = this.querySelector('[cwp-heading]');
      this.productContainer = this.querySelector('[product-slider]');
      this.nextButton = this.querySelector('[navigation-next]');
      this.prevButton = this.querySelector('[navigation-prev]');

      this.debouncedUpdateOnChange = this.debounce(this.updateOnChange.bind(this), 300);

      await this.initSwipers();
      this.attachEvents();
      this.updateOnChange();
    }

    debounce(func, wait) {
      let timeout;
      return function(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    async initSwipers() {
      this.collectionSlider = new Swiper(this.collectionContainer, {
        slidesPerView: 1,
        touchRatio: 1,
        speed: 800,
        loop: false,
        shortSwipes: true,
        allowTouchMove: true,
        simulateTouch: true,
        spaceBetween: 12,
        keyboard: {
          enabled: true,
        },
        mousewheel: {
          enabled: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: false,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
      });

      this.productSlider = new Swiper(this.productContainer, {
        slidesPerView: 1,
        speed: 800,
        spaceBetween: 12,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        loop: false,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
      });

      this.collectionSlider.controller.control = this.productSlider;
      this.productSlider.controller.control = this.collectionSlider;

      // Listen for slide change events
      this.collectionSlider.on('slideChange', this.debouncedUpdateOnChange);
    }

    attachEvents() {
      this.cwpBullets.forEach((bullet, index) => {
        bullet.addEventListener('click', () => {
          this.collectionSlider.slideTo(index);
          this.productSlider.slideTo(index);
        });
      });
    }

    updateOnChange() {
      const currentSlide = this.collectionContainer.querySelector('.swiper-slide-active');
      const link = currentSlide?.querySelector('.card__inner-link')?.href;
      if (this.cwpButton && link) {
        this.cwpButton.href = link;
      }
      if (this.cwpHeading && currentSlide.dataset.title !== '') {
        this.cwpHeading.textContent = currentSlide.dataset.title;
      }
    }
  }

  customElements.define('collection-with-products', CollectionWithProducts);
}